import PropTypes from "prop-types";
import Paragraph from "components/ui/Paragraphs/Paragraph";

function Paragraphs({ items }) {
  return (
    <>
      { items && items.map(item => <Paragraph key={ item.id }
                                              type={ item.bundle }
                                              content={ item }/>) }
    </>
  );
}

Paragraphs.propTypes = {
  items: PropTypes.array,
}
export default Paragraphs;
